var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-columns"},[_c('div',{staticClass:"item col-8 m-0 p-0"},[_vm._v("\n        "+_vm._s(_vm.__('messages.colombians_vat_messages'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-right"},[_c('currency-display',{attrs:{"amount":_vm.breakdown.amount,"showCurrencyCode":true,"applyDecimals":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }